import { type CompatibilityError as DataLabCompatibilityError } from "@decentriq/core";
import { type Key } from "@decentriq/utils";
import { createContext } from "react";
import { type DataLab } from "features/dataLabs/models";
import { type MediaDataRoomVersion } from "features/mediaDataRoom/models";

interface MediaDataRoomDatasetInput {
  datasetHash: string;
  encryptionKey: Key;
}

export interface DataLabCompatibilityResult {
  isCompatible: boolean;
  compatibilityErrors: DataLabCompatibilityError[] | null;
}

export interface MediaDataRoomHandlersContextValue {
  provisionSeedAudience: (props: {
    dataset: MediaDataRoomDatasetInput;
  }) => Promise<void>;
  deprovisionSeedAudience: () => Promise<void>;
  provisionBaseAudience: (props: {
    dataLabId: string;
    usersDataset: MediaDataRoomDatasetInput;
    segmentsDataset?: MediaDataRoomDatasetInput;
    demographicsDataset?: MediaDataRoomDatasetInput;
    embeddingsDataset?: MediaDataRoomDatasetInput;
  }) => Promise<void>;
  deprovisionBaseAudience: (props: {
    withDemographicsDataset: boolean;
    withEmbeddingsDataset: boolean;
    withSegmentsDataset: boolean;
  }) => Promise<void>;
  canProvisionDataLab: (
    dataLab: DataLab
  ) => DataLabCompatibilityResult | Promise<DataLabCompatibilityResult>;
  version: MediaDataRoomVersion;
}

export type MediaDataRoomAbHandlersContextValue =
  MediaDataRoomHandlersContextValue;
export type MediaDataRoomV3HandlersContextValue =
  MediaDataRoomHandlersContextValue;

export interface MediaDataRoomHandlersContextHook {
  (version?: never): MediaDataRoomHandlersContextValue;
  (version: MediaDataRoomVersion.v3): MediaDataRoomV3HandlersContextValue;
  (version: MediaDataRoomVersion.ab): MediaDataRoomAbHandlersContextValue;
}

export const MediaDataRoomHandlersContext =
  createContext<MediaDataRoomHandlersContextValue | null>(null);
MediaDataRoomHandlersContext.displayName = "MediaDataRoomHandlersContext";

export const MediaDataRoomHandlersContextConsumer =
  MediaDataRoomHandlersContext.Consumer;
